// import { UserCookieObj } from './../../views/user/users/users.service';
import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private cookieService: CookieService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Allow-list of public routes that do not require authentication (exact match)
    const PUBLIC_URLS = ['/operations/token-login', '/token-login', '/operations/po-token/po-details', '/marketplace/product-details','/marketplace/product-list', '/marketplace/cart'];
    const currentPath = (state.url || '').split('?')[0];
    if (PUBLIC_URLS.includes(currentPath)) {
      return true;
    }
    // const userdetails: UserCookieObj = this.cookieService.check("user") ? JSON.parse(this.cookieService.get("user")) : null;
    const userdetails:any = this.cookieService.check("user") ? JSON.parse(this.cookieService.get("user")) : null;
    if (!this.isValid(userdetails)) {
      console.log('user not found navigating to signin');
      // Only carry a redirect target when the user was heading somewhere
      // specific. The bare root has no default child route, so sending
      // redirect='/' made the post-login navigation land on an empty layout
      // shell (blank page). Without the param, sign-in falls back to the
      // role-based dashboard. Author: Akarsh Singh · 2026-07-23
      const attempted = (state?.url || '').split('?')[0];
      const isDeepLink =
        attempted && attempted !== '/' && attempted !== '/auth/signin';
      this.router.navigate(
        ['/auth/signin'],
        isDeepLink ? { queryParams: { redirect: state.url } } : {}
      );
      return false;
    }

    return true;
  }

  private isValid(userdetails:any): boolean {
    if (userdetails == null || userdetails.email == null) {
      return false;
    } else {
      return true;
    }
  }
}
